import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Users, BookOpen, FileText, Bell } from 'lucide-react';

export default function TeacherDashboard() {
  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-2">Teacher Dashboard</h1>
          <p className="text-blue-100">Manage your classes and students</p>
        </div>
      </section>
      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-6 mb-12">
            {[
              { icon: Users, label: 'Total Students', value: '120', color: 'bg-blue-100 text-blue-700' },
              { icon: BookOpen, label: 'Classes', value: '5', color: 'bg-green-100 text-green-700' },
              { icon: FileText, label: 'Assignments', value: '15', color: 'bg-purple-100 text-purple-700' },
              { icon: Bell, label: 'Notices', value: '3', color: 'bg-amber-100 text-amber-700' }
            ].map((stat, i) => (
              <GlassCard key={i} className="text-center">
                <div className={`w-16 h-16 ${stat.color} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                  <stat.icon className="w-8 h-8" />
                </div>
                <h3 className="text-3xl font-bold text-blue-900 mb-1">{stat.value}</h3>
                <p className="text-slate-600 font-medium">{stat.label}</p>
              </GlassCard>
            ))}
          </div>
          <h2 className="text-2xl font-bold text-blue-900 mb-6">Quick Actions</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {['Mark Attendance', 'Upload Homework', 'Post Announcement', 'Grade Assignments', 'Send Messages', 'View Reports'].map((action, i) => (
              <GlassCard key={i} className="hover:shadow-xl transition-shadow cursor-pointer text-center p-8">
                <p className="font-semibold text-blue-900 text-lg">{action}</p>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
